import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';

import {NgxCaptchaModule} from 'ngx-captcha';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {RegistrationFormComponent} from './registration-form.component';
import {GoogleLoginModule} from '../google-login/google-login.module';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ErrorInterceptor, JwtInterceptor} from 'af-services';

@NgModule({
  declarations: [RegistrationFormComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    NgxCaptchaModule,
    GoogleLoginModule, FormsModule, ReactiveFormsModule

  ],
  exports: [RegistrationFormComponent],
  providers: [{provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true}],
})
export class  RegistrationFormModule {
  public static forRoot(captchaKey): ModuleWithProviders {

    return {
      ngModule: RegistrationFormModule,
      providers: [

        {
          provide: 'captchaKey',
          useValue: captchaKey
        }
      ]
    };
  }
}
export function RegistrationFormModuleExport() {
  return RegistrationFormModule;
}
